


// src/axios.js
import axios from "axios";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 禁用 NProgress 的 spinner
NProgress.configure({ showSpinner: false });

const request = axios.create({
	// baseURL: 'https://localhost:9990/',
	// baseURL: 'https://121.40.211.28:9999/',
	baseURL: 'https://navigation.itmingchen.cn:9990/',
	timeout: 100000,
})

// 请求拦截
const isExternalRequest = (url) =>
	url.startsWith('http://') || url.startsWith('https://');
request.interceptors.request.use(
	config => {
		NProgress.start();

		const adminToken = window.localStorage.getItem('adminToken');
		const identification = window.localStorage.getItem('identification');

		// 添加认证 Token
		if (adminToken && !isExternalRequest(config.url)) {
			config.headers.Authorization = `Bearer ${adminToken}`;
		}

		// 添加业务标识（如果需要）
		if (identification && !isExternalRequest(config.url)) {
			config.headers.identification = identification;
		}

		return config;
	}
)

// 响应拦截
request.interceptors.response.use(
	response => { // 将参数名改为 response
		NProgress.done()
		const identification = response.headers.identification // 正确访问 response.headers
		if (identification) {
			//保存身份标识到localStorage
			window.localStorage.setItem('identification', identification)
		}
		return response.data // 正确返回 response.data
	},
	error => {
		NProgress.done();
		return Promise.reject(error);
	}
)

export default request
